import { boxPropsType } from "../Box";
export const actionBarPropsType = boxPropsType.complete({
    abort: true,
    disabled: true,
    primary: true,
    secondary: true,
    abortOnEsc: true,
    maxExpectedButtonSize: true,
    noAbort: true,
});
export const formActionBarPropsType = actionBarPropsType.complete({
    form: true,
    hideResetButton: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9BY3Rpb25CYXIvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsT0FBTyxFQUFZLFlBQVksRUFBRSxNQUFNLFFBQVEsQ0FBQztBQTRDaEQsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsWUFBWSxDQUFDLFFBQVEsQ0FBaUI7SUFDdEUsS0FBSyxFQUFFLElBQUk7SUFDWCxRQUFRLEVBQUUsSUFBSTtJQUNkLE9BQU8sRUFBRSxJQUFJO0lBQ2IsU0FBUyxFQUFFLElBQUk7SUFDZixVQUFVLEVBQUUsSUFBSTtJQUNoQixxQkFBcUIsRUFBRSxJQUFJO0lBQzNCLE9BQU8sRUFBRSxJQUFJO0NBQ2QsQ0FBQyxDQUFDO0FBT0gsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQ2pDLGtCQUFrQixDQUFDLFFBQVEsQ0FBcUI7SUFDOUMsSUFBSSxFQUFFLElBQUk7SUFDVixlQUFlLEVBQUUsSUFBSTtDQUN0QixDQUFDLENBQUMifQ==